import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalDepositCreateProps {}

const ModalDepositCreate = ({}: ModalDepositCreateProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.createDeposit');
  const onClose = () => {
    closeSingleModal('createDeposit');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Novo depósito"
      height={'auto'}
      width={'70vw'}
    >
      <Form.Export.Deposit.Create />
    </Modal>
  );
};

export default ModalDepositCreate;
